const COMMENTS = [
    {
        dishId:0,
        id:0,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Billal",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {   dishId:0,
        id:1,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Farabi",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {
        dishId:0,
        id:2,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Hasan",
        date:"2021-10-16T17:57:28.556094Z"
    },

    {
        dishId:1,
        id:3,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Billal",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {   dishId:1,
        id:4,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Farabi",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {
        dishId:1,
        id:5,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Hasan",
        date:"2021-10-16T17:57:28.556094Z"
    },

    {
        dishId:2,
        id:6,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Billal",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {   dishId:2,
        id:7,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Farabi",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {
        dishId:2,
        id:8,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Hasan",
        date:"2021-10-16T17:57:28.556094Z"
    },

    {
        dishId:3,
        id:9,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Billal",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {   dishId:3,
        id:10,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Farabi",
        date:"2021-10-16T17:57:28.556094Z"
    },
    {
        dishId:3,
        id:11,
        rating:5,
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur, repudiandae",
        author:"Hasan",
        date:"2021-10-16T17:57:28.556094Z"
    },
    
    
]
export default COMMENTS;